import { Backdrop, ButtonPrimary, ButtonTertiary, DialogConfirmation, Type, } from '@spotify-internal/encore-web';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLoginDialogStore } from '../stores/loginDialogStore';
import TextDir from '../lib/TextDir';
export const LoginConfirmationDialog = ({ onLogin, onContinue, }) => {
    const { t, i18n } = useTranslation();
    const { showLoginDialog, setLoginDialogStatus, setLoginConfirmationStatus } = useLoginDialogStore();
    const handleLoginClick = useCallback(() => {
        setLoginConfirmationStatus('login');
        setLoginDialogStatus({ show: false });
        onLogin === null || onLogin === void 0 ? void 0 : onLogin();
    }, [onLogin, setLoginConfirmationStatus, setLoginDialogStatus]);
    const handleNoThanksClick = useCallback(() => {
        setLoginConfirmationStatus('continue');
        setLoginDialogStatus({ show: false });
        onContinue === null || onContinue === void 0 ? void 0 : onContinue();
    }, [onContinue, setLoginConfirmationStatus, setLoginDialogStatus]);
    if (!showLoginDialog) {
        return null;
    }
    return (React.createElement(Backdrop, { center: true },
        React.createElement(DialogConfirmation, { dialogTitle: t('LOGIN_DIALOG_QUESTION_TEXT'), id: "dialogWithBackdrop", body: React.createElement("div", null,
                React.createElement(Type, { as: "p" },
                    React.createElement(TextDir, { locale: i18n.language }, t('LOGIN_DIALOG_WITH_UNAUTHENTICATED_INFO_TEXT')))), dir: i18n.dir(), footer: React.createElement("div", null,
                React.createElement(ButtonTertiary, { "data-testid": "no-login-btn", condensed: true, onClick: handleNoThanksClick },
                    React.createElement("span", null,
                        React.createElement(TextDir, { locale: i18n.language }, t('NO_THANKS_TEXT')))),
                React.createElement(ButtonPrimary, { "data-testid": "login-btn", onClick: handleLoginClick },
                    React.createElement(TextDir, { locale: i18n.language }, t('LOG_IN_TEXT')))) })));
};
